// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3P_Bt","logo__one":"Logo_logo__one__3Iyld"};